import { useQuery as useApolloQuery } from "@apollo/client";

export const useQuery: typeof useApolloQuery = (document, props) => {
  const {
    data,
    loading: queryLoading,
    ...rest
  } = useApolloQuery(document, { fetchPolicy: "cache-first", ...props });

  const loading = (() => {
    if (props?.fetchPolicy === "cache-and-network") {
      return queryLoading && !data;
    }
    return queryLoading;
  })();

  return { data, loading, ...rest };
};
